import { render, staticRenderFns } from "./BoardUserFeature.vue?vue&type=template&id=14742430&lang=pug"
import script from "./BoardUserFeature.vue?vue&type=script&lang=js"
export * from "./BoardUserFeature.vue?vue&type=script&lang=js"
import style0 from "./BoardUserFeature.vue?vue&type=style&index=0&id=14742430&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports